import React, { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { extractDateFromStr, getLatestUpdatedObject } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import PdfZipItem from "../../components/PdfZipItem";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const OfferWorks = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const { getText } = useLanguageTranslation();
  const { data: offerWorksData = [], isLoading: offerWorksIsLoading } =
    useGetProtectedApiDataQuery({ url: "offer_works", lang: languageType });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(offerWorksData)?.changed);
  }, [offerWorksData]);

  if (offerWorksIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/offer-works"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th> {getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offerWorksData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <PdfZipItem
                              filePath={item?.field_download}
                              filesize={item?.filesize}
                            />
                            {/* <a
                              href={`${item?.field_download}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <div className="pdf-icon">
                                <img
                                  src="./images/pdf-icon.png"
                                  alt=""
                                  className="mr-2"
                                />
                              </div>
                            </a> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* <!--table grid end here--> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferWorks;
